import React, {useEffect, useState} from "react";
import "./LoginPage.sass"
import TextFieldEdit from "../../../_components/common/fields/TextFieldEdit";
import ButtonComponent from "../../../_components/common/buttons/ButtonComponent";
import {useSelector, useDispatch} from "react-redux";
import {useNavigate} from "react-router";
import {isAuthenticated, login, recoveryPassword} from "../../../_actions/auth/authService";
import {FAILED, LOADING, SUCCESS} from "../../../common/statuses";
import Spinner from "./Spinner";
import {HOME, MAIN} from "../../../common/links";

export default function LoginPage() {
    const [forgotPassword, setForgotPassword] = useState(false);

    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")

    const {status, retrievalStatus} = useSelector(state => state.auth)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (status === SUCCESS) {
            navigate(HOME)
        }
    }, [status, dispatch])
    useEffect(() => {
        if (retrievalStatus === SUCCESS || retrievalStatus === FAILED) {
            setTimeout(() => {
                navigate(MAIN);
            }, 7000);
        }
    }, [retrievalStatus])
    useEffect(() => {
        document.title = 'КьюАй - Авторизация';
        return () => {
            document.title = 'КьюАй - Центр детского развития';
            dispatch(isAuthenticated())
        }
    }, [])

    if (status === LOADING || retrievalStatus === LOADING) {
        return <Spinner/>
    }

    const body = {
        username: username,
        password: password
    }

    const renderLogin = () => {
        return (
            <div className="login-wrapper">
                <div className="login-title">
                    <div>Вход в личный кабинет</div>
                </div>
                <form style={{display: "contents"}} onSubmit={() => dispatch(login(body))}>
                    <div className="login-fields">
                        <TextFieldEdit label="E-mail"
                                       value={username}
                                       onChange={(e) => setUsername(e.target.value)}/>
                        <TextFieldEdit label="Пароль"
                                       type="password"
                                       value={password}
                                       onChange={(e) => setPassword(e.target.value)}/>
                    </div>
                    <div className="login-buttons">
                        <ButtonComponent type="submit">Войти</ButtonComponent>
                        <div className="login-forgot-password" onClick={() => setForgotPassword(true)}>
                            Забыли пароль?
                        </div>
                    </div>
                </form>
            </div>
        )
    }

    const renderForgotPassword = () => {
        return (
            <div className="login-wrapper">
                <div className="login-title">
                    <div>Восстановление пароля</div>
                </div>
                {
                    (retrievalStatus === SUCCESS || retrievalStatus === FAILED)
                        ? <div style={{textAlign: 'center'}}>На указанный электронный адрес будет отправленно сообщение с новым паролем, проверьте
                            почту.</div>
                        : <div style={{display: "contents"}}>
                            <div className="login-fields">
                                <TextFieldEdit label="E-mail"
                                               value={username}
                                               onChange={(e) => setUsername(e.target.value)}/>
                            </div>
                            <div className="forgot-buttons">
                                <ButtonComponent onClick={() => setForgotPassword(false)}>Отменить</ButtonComponent>
                                <ButtonComponent onClick={() => dispatch(recoveryPassword({username}))}>Восстановить</ButtonComponent>
                            </div>
                        </div>
                }
            </div>
        )
    }

    return forgotPassword ? renderForgotPassword() : renderLogin();
}